import React, { useState } from "react";
import Step from "../../../../atoms/Wizard/Step";

import styles from "./MainApp.organisms.Product.ProductSigleLoadWizard.ProductStepRecommendations.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
import { Container, Grid } from "@material-ui/core";
import useRequest from "hooks/useRequest";
import LocalizationProductFilter from "../../../../../../views/Admin/Stock/LocalizationProduct/LocalizationProductFilter";
import LocalizationProductItem from "../../../../../../shared/components/LocalizationProductItem";

const ProdStepRecommendations = ({
  product,
  handleChange,
  handleBlur,
  handleChangeRecommendedProducts,
  handleChangeRecommendedProductsDelete,
  errors,
  goBackFunc
}) => {
  const [itemId, setItemId] = useState(null);
  const [itemIds, setItemIds] = useState(product?.recommended_products || []);
  const [mobilePanelOpen, setMobilePanelOpen] = useState(false);
  const [products, setProducts] = useState(null);

  const goBack = () => {
    if (goBackFunc) goBackFunc(1);
  };

  const handleSelectedItem = item => {
    setProducts(null);
    if (item) {
      setMobilePanelOpen(false);
      setItemId(item.key);
      setItemIds([...itemIds, item.key]);
      handleChangeRecommendedProducts(item?.key);
    }
  };

  const handleDeleteItem = (itemId) => {
    setItemIds(itemIds.filter(id => id !== itemId));
    handleChangeRecommendedProductsDelete(itemId);
  };

  const tableContentNew = (

    <div className={styles["outter-wrapper"]}>
      <Container className={styles["container-localization-products"]}>
        <LocalizationProductFilter handleApply={handleSelectedItem} />
        <div className={styles["product-search-wrapper"]}>
          {itemIds.map(element => (
            <div className={styles["grid-wrapper"]} key={element}>
              <Grid className={styles["grid-container"]}>
                <div className={styles["localization-product-item"]}>
                  <LocalizationProductItem key="element" itemId={element} />
                  <i
                    className={`${styles["icon-iconos_eliminar"]} icon-iconos_eliminar`}
                    onClick={() => handleDeleteItem(element)}
                  />
                </div>
              </Grid>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );

  const stepContent = (
    <div className="product-step-3.5-content recommendations">
      <div className="prod-step-3.5-field" data-automation-id="input-weight">
        {tableContentNew}
      </div>
    </div>
  );

  return (
    <div className={styles["product-step-3_5-container"]}>
      <Step
        title={i18n.t("recommendations") + " (" + i18n.t("optional") + ")"}
        content={stepContent}
        goBackFunc={goBack}
      />
    </div>
  );
};

export default ProdStepRecommendations;
